module.exports = function(app) {
    app.directive('fieldMatch', ["$window", "$compile", function($window, $compile) {
        return {
            restrict: "A",
            require: "ngModel",scope:{ssnValue:"=fieldMatch"},
            link: function (scope, elm, attrs, ctrl) {
                ctrl.$validators.fieldMatch = function (modelValue, viewValue) {
                    return (modelValue == scope.ssnValue);
                };
                scope.$watch("ssnValue",function ( ) {
                    ctrl.$validate();

                });
            }
        };
    }]);
};


